import { connect } from 'react-redux'
import SubValuations from './SubValuations'

import componentDidMount from './Handlers/componentDidMount'
import onCloseSubValuationModal from './Handlers/onCloseSubValuationModal'

const mapStateToProps = (state) => ({
  subValuationModal: state.screens.SubProject.SubValuations.subValuationModal,
})

const actionCreators = {
  componentDidMount,
  onCloseSubValuationModal,
}

export default connect(mapStateToProps, actionCreators)(SubValuations)
